<template>
  <slot
    name="content"
    :requestMultipleInformationPack="requestMultipleInformationPack"
    :toggleEnquiryForm="toggleEnquiryForm"
    :showInfoPackForm="showInfoPackForm"
    :checkEmailPreferenceChildren="checkEmailPreferenceChildren"
    :showEnquiryId="showEnquiryId"
    :saveRemoveFavourite="saveRemoveFavourite"
    :tileClick="tileClick"
  >
  </slot>
</template>
<script setup>

  import {nextTick, ref} from 'vue'
  import {useFormSubmit} from '../../composables/useFormSubmit'
  import useGlobalStore from '../../store/globalStore'

  const showEnquiryId = ref(false)
  const globalStore = useGlobalStore()
  const {toggleEnquiryForm, saveRemoveFavourite} = useFormSubmit()

  const checkEmailPreferenceChildren = (event) => {
    const parentEl = event.target.parentElement;
    let childEls = parentEl.querySelectorAll('input[name="email_preferences[]"]');

    for (let i = 0; i < childEls.length; ++i) {
      childEls[i].checked =  (event.target.checked);
    }
  }

  const showInfoPackForm = async (villageId, villageName, action, e) => {
    const modelName = action === 'email-village' ? 'emailEnquiryModal' : 'villageInfoPackModal';
    globalStore.setModal(
      {
        name: modelName,
        id: villageId,
        customField: action,
        title: villageName,
        descriptionPlaceholder: `Please send me an information pack for ${villageName}`,
      }
    )

    await nextTick()
    const ele = e.target;
    document.getElementById('property_name').value = villageName;
    document.getElementById('operator_name').value = ele.dataset.operatorName;
    document.getElementById('operator_id').value = ele.dataset.operatorId;
    document.getElementById('subscription').value = ele.dataset.subscription;
    document.getElementById('enquiry_region').value = ele.dataset.enquiryRegion;
    document.getElementById('enquiry_district').value = ele.dataset.enquiryDistrict;
  }

  const requestMultipleInformationPack = () => {
    const checkboxes = document.getElementsByName('info-pack[]');
    let isChecked = false;
    let villageNames = '';
    let villageIds = '';

    for (let i=0; i<checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        isChecked = true;
        villageNames += `${checkboxes[i].dataset.villageName}<br>`;
        villageIds += `${checkboxes[i].dataset.villageId},`
      }
    }

    if (!isChecked) {
      const msgBoxs = document.getElementsByClassName('message');

      for (let i = 0; i < msgBoxs.length; i++) {
        const msgBox = msgBoxs[i];
        msgBox.style.display = 'block';

        setTimeout(function () {
          msgBox.style.opacity = '0';

          setTimeout(function () {
            msgBox.style.display = 'none';
            msgBox.style.opacity = '1';
          }, 1000)
        }, 4000);
      }
    } else {

      globalStore.setModal(
        {
          name: 'villageInfoPackMultipleModal',
          id: villageIds,
          title: villageNames,
          descriptionPlaceholder: 'Please send me an information pack for these villages. Thanks',
        }
      )
    }
  }

  const tileClick = (id, e) => {
    const ele = e.target.closest(`#tile_${id}`);
    this.pushTileClickData(ele);
  };
</script>
